export enum LoadingState {
  INIT = 'INIT',
  LOADING = 'LOADING',
  LOADED = 'LOADED',
}

export type ErrorState<Error = Record<string, unknown>> = Readonly<{ error: Error }>;
export type FetchState<Error = Record<string, unknown>> = LoadingState | ErrorState<Error>;
